import styled from 'styled-components';
import { themeGet } from '@magalu/stereo-ui-styles';
import { Chip, Grid } from '../../../atoms';
import { AddWishlistButton } from '../../../molecules';
import { LIST, MINIATURE } from '../../../constants';
export const HeaderEl = styled(Grid)`
  grid-template-columns: 1fr ${({
  displayMode,
  sponsored,
  isMagaluIndica
}) => displayMode !== LIST && isMagaluIndica || displayMode === MINIATURE && sponsored ? '20px' : ''};
  margin-bottom: ${themeGet('space.1')}px;
  ${props => props.displayMode === LIST && `
    grid-column-start: 3;
    grid-row-start: 1;
    align-self: start;
  `}
`;
export const MagaluIndica = styled(Chip).attrs(props => Object.assign({}, props))`
  justify-self: start;
`;
export const WishlistBtn = styled(AddWishlistButton).attrs(props => Object.assign({
  width: 20,
  height: 20
}, props))`
  justify-self: end;
  max-width: 20px;
`;